import { createContext, useContext, useReducer } from 'react';
import { Modal } from '../components/Modal/Modal';

const reducer = (state: State, updates: Partial<State>): State => {
  return { ...state, ...updates };
};

type State = {
  className?: string;
  customMerlinLogoColor?: string;
  element?: JSX.Element;
  handleMerlinLogo: boolean;
  isFullScreenElement: boolean;
  isClosable: boolean;
  title: string;
  infoTooltip?: string;
  height: 'auto' | 'fixed';
  z?: number;
  padding: 'none' | 'base' | 'large' | 'huge';
  closeModal(): void;
  dispatch: React.Dispatch<Partial<State>>;
  setElement(p: JSX.Element): void;
  setTitle(p: string): void;
};

const localState: State = {
  className: undefined,
  customMerlinLogoColor: undefined,
  element: undefined,
  handleMerlinLogo: false,
  isFullScreenElement: false,
  isClosable: true,
  title: '',
  infoTooltip: '',
  padding: 'none',
  height: 'fixed',
  closeModal: () => {},
  dispatch: () => {},
  setElement: () => {},
  setTitle: () => {},
};

const ModalContext = createContext(localState);

export const ModalProvider: React.FC = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, localState);

  const closeModal = () => dispatch({ ...localState });

  const setElement = (element: JSX.Element) => dispatch({ element });

  const setTitle = (title: string) => dispatch({ title });

  const value = {
    ...state,
    closeModal,
    dispatch,
    setElement,
    setTitle,
  };

  return (
    <ModalContext.Provider value={value}>{children}</ModalContext.Provider>
  );
};

export const ModalPage = () => {
  const {
    className,
    customMerlinLogoColor,
    element,
    handleMerlinLogo,
    isFullScreenElement,
    isClosable,
    infoTooltip,
    title,
    z,
    padding,
    height,
    closeModal,
  } = useModalContext();

  return (
    <Modal
      className={className}
      customMerlinLogoColor={customMerlinLogoColor}
      element={element || <></>}
      handleMerlinLogo={handleMerlinLogo}
      isFullScreenElement={isFullScreenElement}
      isOpen={typeof element !== 'undefined'}
      onCloseClick={closeModal}
      isClosable={isClosable}
      infoTooltip={infoTooltip}
      title={title}
      z={z}
      padding={padding}
      height={height}
    />
  );
};

export const useModalContext = () => useContext(ModalContext);
